import React, {Component} from "react";


class InputTextarea extends Component {
    constructor(props) {
        super(props);

        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        this.state = {
            [name]: this.props.blockItem.values[0]
        };

        const e = {target: {name: name, value: this.props.blockItem.values[0]}}
        this.props.onChange(e);

        this.change = this.change.bind(this);
    }

    /*static getDerivedStateFromProps(props, state) {
        const name = "BLOCK_ITEM_" + props.blockItem.id + (props.blockItem.isArray ? "[]" : "");
        if (props.blockItem.values[0] !== state[name]) {
            const e = {target: {name: name, value: props.blockItem.values[0]}}
            props.onChange(e);
            return {
                [name]: props.blockItem.values[0]
            };
        }
    }*/

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        this.props.onChange(e);
    }

    render() {
        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        return (
            <div className="coreBlockItem-value" style={JSON.parse(this.props.blockItem.inputCss)}>
                <textarea type="text"
                            className="coreBlockItem-input coreBlockItem-typeTextarea"
                            autoComplete="off"
                            name={name}
                            value={this.state[name]}
                            onChange={this.change}
                            readOnly={this.props.blockItem.isReadOnly}/>
            </div>
        );
    }
}

export default InputTextarea;